import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useUiCardItemIdsByCards = (cardIds: string[] | undefined) : string[] | undefined => {
  const uiCardItemDb = useSelector((state: RootState) => state.uiCardItemDb);
  if (cardIds === undefined) return;
  let ids: string[] = [];
  cardIds.forEach(cardId => {
    const itemIds = Object.keys(uiCardItemDb.uiCardItems).filter(id => uiCardItemDb.uiCardItems[id].cardId === cardId);
    ids.push(...itemIds);
  })
  return ids;
}

export default useUiCardItemIdsByCards;
